import type { UserType } from "@/types/graphql/partner";

export const getInitials = (user: UserType) => {
  const firstName = user.firstName?.charAt(0) || "";
  const lastName = user.lastName?.charAt(0) || "";
  const initials = (firstName + lastName).toUpperCase();
  if (initials) return initials;

  if (user.email) {
    return user.email.split("@")[0].charAt(0).toUpperCase();
  }

  if (user.phone) {
    return user.phone.slice(-1);
  }

  return "U";
};
